// extracted by mini-css-extract-plugin
export default {"container":"Birthday_container__LqyoZ","countDownContainer":"Birthday_countDownContainer__gAEdj","countdownSquare":"Birthday_countdownSquare__3+EY+","colon":"Birthday_colon__Itkc6"};